import React, { useRef } from 'react';
import type { RefObject } from 'react';

import { Ellipse, Line, Rect } from 'react-konva';
import Konva from 'konva';
import type { KonvaEventObject } from 'konva/lib/Node';

import type { ShapeElementType } from 'Components/CanvasEditor/types';

interface ShapeElementProps {
  element: ShapeElementType;
  onTransformEnd: (e: KonvaEventObject<Event>) => void;
  onDragStart: (e: KonvaEventObject<DragEvent>) => void;
  onDragEnd: (e: KonvaEventObject<DragEvent>) => void;
}

export default function Shape({
  element,
  onTransformEnd,
  onDragStart,
  onDragEnd,
}: ShapeElementProps) {
  const shapeRef = useRef<Konva.Rect | Konva.Ellipse | Konva.Line>(null);

  const commonProps = {
    id: element.id,
    name: 'object',
    x: element.x,
    y: element.y,
    visible: element.visible,
    rotation: element.rotation,
    fill: element.fill,
    stroke: element.stroke,
    strokeWidth: element.strokeWidth,
    draggable: element.draggable,
    perfectDrawEnabled: true,
    onDragStart,
    onDragEnd,
    onTransformEnd,
  };

  if (element.type === 'rect')
    return (
      <Rect
        ref={shapeRef as RefObject<Konva.Rect>}
        {...commonProps}
        width={element.width || 100}
        height={element.height || 100}
        cornerRadius={element.cornerRadius || 0}
      />
    );

  if (element.type === 'circle')
    return (
      <Ellipse
        ref={shapeRef as RefObject<Konva.Ellipse>}
        {...commonProps}
        radiusX={element.radiusX || 50}
        radiusY={element.radiusY || 50}
      />
    );

  if (element.type === 'line')
    return (
      <Line
        ref={shapeRef as RefObject<Konva.Line>}
        {...commonProps}
        closed={element.closed}
        points={element.points || [0, 0, 100, 100]}
      />
    );

  return null;
}
